import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Loader2, FilePlus, StickyNote, GitBranch, Mail, Briefcase, CreditCard } from "lucide-react";

const ICONS = { created: FilePlus, note: StickyNote, stage: GitBranch, email: Mail, booking: Briefcase, payment: CreditCard };
const COLORS = { created: "#6B7280", note: "#C79A3B", stage: "#5B2A83", email: "#2E6BB0", booking: "#12263A", payment: "#1F6B3B" };

export function QuoteTimeline({ quoteId }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get(`/admin/quote/${encodeURIComponent(quoteId)}/timeline`)
      .then(r => setItems(r.data.items || [])).catch(() => setItems([]));
  }, [quoteId]);

  if (items === null) return <div className="py-8 text-center text-sm text-[#6B7280]"><Loader2 size={14} className="animate-spin inline mr-2" /> Loading timeline…</div>;

  return (
    <div className="border border-[#E5E7EB] bg-white p-5" data-testid="quote-timeline">
      <div className="label-eyebrow mb-4">Everything that happened, newest first</div>
      {items.length === 0 ? (
        <div className="text-sm text-[#9CA3AF] italic">Nothing yet.</div>
      ) : (
        <ol className="relative border-l-2 border-[#F0EAE0] ml-2 space-y-5">
          {items.map((e, i) => {
            const Icon = ICONS[e.type] || StickyNote;
            const color = COLORS[e.type] || "#6B7280";
            return (
              <li key={`${e.type}-${i}`} className="ml-5 relative" data-testid={`timeline-event-${i}`}>
                <span className="absolute -left-[29px] top-0.5 w-4 h-4 rounded-full bg-white border-2 flex items-center justify-center" style={{ borderColor: color }}>
                  <Icon size={9} style={{ color }} />
                </span>
                <div className="text-sm font-semibold text-[#12263A]">{e.label}</div>
                {e.detail && <div className="text-xs text-[#6B7280] mt-0.5 whitespace-pre-wrap">{e.detail}</div>}
                <div className="text-[11px] text-[#9CA3AF] mt-0.5">
                  {e.at ? new Date(e.at).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "—"}
                  {e.by ? ` · ${e.by}` : ""}
                </div>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
}
